export const characterSeparation = 0;
export const syllableSeparation = 0.25;
export const startOffset = 0;
export const edgeFade = 0.1;
export const compressorOptions = {
    threshold: -22,
    knee: 24,
    ratio: 3,
    attack: 0.01,
    release: 0.2,
} satisfies DynamicsCompressorOptions;
